const ErrorMessage = () => {
  return (
    <>
      <h1 className="text-[var(--main-color)] text-center text-2xl">Oops :(</h1>
      <h2 className="text-[var(--main-color)] text-center text-2xl">
        Failed to fetch characters
      </h2>
    </>
  );
};

export default ErrorMessage;
